import { toast } from 'react-toastify';

import {
  takeLatest, call, put, all,
} from 'redux-saga/effects';

import axios from '../../../services/axios';

import {
  Types as ValveTypes,
  setValveCalibrationToWorkSuccess,
  setValveCalibrationToWorkFailure,
  updateValveCalibrationSuccess,
  updateValveCalibrationFailure,
  deleteValveCalibrationSuccess,
  deleteValveCalibrationFailure,
} from './actions';

function responseErrorReport(error) {
  switch (error) {
    case 400:
      toast.info('Conteudo do formulario invalido, verifique se todos os campos estão preenchidos devidamente!');
      break;
    case 401:
      toast.warn('Usuario não Autorizado a realizar esta ação!');
      break;
    case 404:
      toast.warn('Conteudo cadastrado indevidamente!');
      break;
    case 500:
      toast.error('Ocorreu um erro inesperado no servidor, tente novamente mais tarde');
      break;
    default:
      toast.error('Ocorreu um erro inesperado no servidor, tente novamente mais tarde');
      break;
  }
}

function* setValveCalibrationToWork({ payload }) {
  if (!payload) {
    window.location.href = `${process.env.REACT_APP_HOST}/dashboard`;
    yield put(setValveCalibrationToWorkFailure());
    return;
  }

  const {
    token, tender, client, seal, createdAt,
  } = payload.match.params;
  try {
    const id = parseInt(token.split('ui')[1].split('a')[0], 10);
    yield put(
      setValveCalibrationToWorkSuccess({
        id,
        tender,
        client,
        seal,
        createdAt,
      }),
    );
  } catch (err) {
    toast.warn('Alteração de parametros de rota invalida!');
    window.location.href = `${process.env.REACT_APP_HOST}/dashboard`;
    yield put(setValveCalibrationToWorkFailure());
  }
}

function* updateValve({ payload }) {
  if (!payload) {
    window.location.href = `${process.env.REACT_APP_HOST}/dashboard`;
    yield put(updateValveCalibrationFailure());
  }

  try {
    yield call(axios.put, `${process.env.REACT_APP_API_UPDATE_VALVE}/${payload.id}`, {
      certificateNumber: payload.certificateNumber,
      ...(payload.tag === undefined ? {} : { tag: payload.tag }),
    });
    toast.success('Numero do Certificado de Calibração Salvo com Sucesso!');
    yield put(updateValveCalibrationSuccess(payload));
  } catch (err) {
    console.log(err);
    yield put(updateValveCalibrationFailure());
  }
}

function* deleteValve({ payload }) {
  if (!payload) {
    return yield put(deleteValveCalibrationFailure());
  }
  try {
    yield call(axios.delete, `${process.env.REACT_APP_API_DELETE_VALVE}/${payload.id}`);
    toast.success('Calibração de Válvula Deletada com sucesso!');
    return yield put(deleteValveCalibrationSuccess(payload.id));
  } catch (err) {
    if (!err.response) {
      console.log(err);
      toast.error('Ops, algum error inesperado aconteceu, tente novamente!');
      return yield put(deleteValveCalibrationFailure());
    }
    responseErrorReport(err.response.status);
    return yield put(deleteValveCalibrationFailure());
  }
}

export default all([
  takeLatest(ValveTypes.SET_VALVE_TO_WORK_REQUEST, setValveCalibrationToWork),
  takeLatest(ValveTypes.VALVE_UPDATE_REQUEST, updateValve),
  takeLatest(ValveTypes.VALVE_DELETE_REQUEST, deleteValve),

]);
